import { Alert } from '@mui/material'
import IntegrationsGrid from './IntegrationsGrid'
import IntegrationsModalToolbar from './IntegrationsModalToolbar'
import { integrationsEmptyMessage } from './integrationsEmptyMessage.js'
import styles from './integrationsModal.module.scss'

export default function IntegrationsModalBody({ model }) {
  return (
    <div className={styles.body}>
      <div className={styles.main}>
        {model.connectError ? (
          <Alert severity="error" onClose={model.clearConnectError}>
            {model.connectError}
          </Alert>
        ) : null}
        <IntegrationsModalToolbar
          query={model.query}
          onQueryChange={model.setQuery}
          visibleCount={model.visibleCount}
          matchCount={model.matchCount}
          totalCount={model.totalCount}
        />
        <div className={styles.mainScroll}>
          <div className={styles.createNewHeading}>
            <strong>Create a New Connection</strong>
            <span>Connect to 1,000+ pre-built integrations, any API, or MCP.</span>
          </div>
          <IntegrationsGrid
            apps={model.gridApps}
            emptyMessage={integrationsEmptyMessage(model)}
            onConnect={model.onConnect}
            connectingSlug={model.connectingSlug}
            hasMore={model.hasMore}
            onShowMore={model.showMore}
          />
        </div>
      </div>
    </div>
  )
}
